import { Box, Typography } from '@mui/material';
import './orderSummaryCardB2C.scss';

interface IOrderSummaryCardProps {
  createdBy: string;
  ordNumber: number;
}

const OrderSummaryCard = ({ createdBy, ordNumber }: IOrderSummaryCardProps) => {
  return (
    <Box className="orderSummaryCardB2C">
      {/* Left Side - Order Information */}
      <Box className="orderSummaryCardLeft">
        <Typography variant="body2" className="orderSummaryCardCreatedByText">
          Created By {createdBy}
        </Typography>
        <Typography variant="h6" className="orderSummaryCardOrderNumberText">
          ORD # {ordNumber}
        </Typography>
      </Box>
    </Box>
  );
};

export default OrderSummaryCard;
